import { withApollo } from 'react-apollo';
import ShareWrapper from 'chameleon-packages/units/components/ShareWrapper';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import {
  handleTelemetry,
  TELEMETRY_EVENTS,
} from 'legacy-src/utility/telemetry';
import React from 'react';
import PropTypes from 'prop-types';
import BodyContentLayout from './layout/BodyContentLayout';
import LeftContentLayout from './layout/LeftContentLayout';
import RightContentLayout from './layout/RightContentLayout';
import ResourceItem from './ResourceItem';
import JstorLink from './JstorLink';
import LTILink from './LTILink';
import { ResourceTypes } from '../utils/constants';
import {
  getLinkComponentByType,
  isResourceWithJstorLink,
} from '../utils/Utils';

export const isSmithsonianResource = (name) =>
  name.toLowerCase().includes('smithsonian');

const SourceResources = ({
  title,
  label,
  items,
  useClassroomResourceAddress,
  showIcon,
  unitNumber,
  subunitTitle,
  iconName,
  masterSubjectId,
}) => {
  const isReviewUnit = unitNumber === '0';
  const hasResourceIcon = iconName === 'Resources';
  const isTeacherResource =
    isReviewUnit && hasResourceIcon && subunitTitle === 'Teacher Resources';
  const isStudentResource =
    isReviewUnit && hasResourceIcon && subunitTitle === 'Student Resources';
  let icon;
  if (isTeacherResource) {
    icon = 'teacher_resources';
  } else if (isStudentResource) {
    icon = 'student_resources';
  } else {
    icon = 'more_resources';
  }

  return (
    <BodyContentLayout>
      <RightContentLayout
        title={title}
        showIcon={showIcon}
        label={label}
        icon={icon}
      />

      <LeftContentLayout>
        {items.map((item) => {
          const {
            displayName,
            description,
            url,
            id,
            contentType,
            isShareable,
            resourceId,
            __typename,
          } = item;

          if (__typename === ResourceTypes.LTI) {
            return (
              <ResourceItem key={id} iconName="resource_indicator">
                <LTILink
                  resourceId={resourceId}
                  url={url}
                  aria-label={displayName}
                >
                  <span className="font-medium hover:underline hover:text-black text-black text-base mr-4 leading-normal">
                    {displayName}
                  </span>
                  <span className="font-normal hover:underline text-base hover:text-black text-black leading-normal">
                    {description}
                  </span>
                </LTILink>
              </ResourceItem>
            );
          }

          const LinkComponent = isResourceWithJstorLink(url)
            ? JstorLink
            : getLinkComponentByType(contentType);

          return (
            <ResourceItem key={id} iconName="resource_indicator">
              <LinkComponent
                resource={item}
                isSigned={false}
                contentType={contentType}
                useClassroomResourceAddress={useClassroomResourceAddress}
                aria-label={displayName}
                url={url}
                onClick={() =>
                  handleTelemetry(
                    'course_guide',
                    TELEMETRY_EVENTS.openSourceResource,
                    {
                      resourceId,
                      contentType,
                      subjectId: masterSubjectId,
                    },
                  )
                }
              >
                <span className="font-medium hover:underline hover:text-black text-black text-base mr-4 leading-normal">
                  {displayName}
                </span>
                {isSmithsonianResource(displayName) && (
                  <Icon name="smithsonian" className="align-middle mr-4" />
                )}
                <span className="font-normal hover:underline text-base hover:text-black text-black leading-normal">
                  {description}
                </span>
              </LinkComponent>
              {isShareable && (
                <div className="ml-auto">
                  <ShareWrapper resource={item} unitNumber={unitNumber} />
                </div>
              )}
            </ResourceItem>
          );
        })}
      </LeftContentLayout>
    </BodyContentLayout>
  );
};

SourceResources.propTypes = {
  title: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  items: PropTypes.array.isRequired,
  useClassroomResourceAddress: PropTypes.bool.isRequired,
  showIcon: PropTypes.bool,
  unitNumber: PropTypes.string.isRequired,
  subunitTitle: PropTypes.string,
  iconName: PropTypes.string,
};

SourceResources.defaultProps = {
  title: 'Sources',
  label: '',
  iconName: '',
  subunitTitle: '',
  showIcon: true,
};

export default withApollo(SourceResources);
